import Title from '@/components/Title/index.vue';
export default {
  name: 'function',
  components: {
    Title
  },
  data() {
    return {
      imageFunc: require('@/assets/images/securitiessolutions/securitiesSolutions-appscenariobg.png'),
      itemList: [{
        title: '网上开户',
        icon: require('@/assets/images/securitiessolutions/securitiesSolutions-onlineaccoutopenning.png'),
        desc: 'Users can create exclusive shorts templates through simple dragging, collocation and data access, and can finish both creation and post of shorts in as little as 10 seconds with templates such as industry chain diagnosis, market review, opening risk forecasts, weekly hot stocks, results review and fund interpretation provided by us',
        activeIcon: require('@/assets/images/securitiessolutions/securitiesSolutions-onlineaccoutopenning-active.png'),
        index: 1
      }, {
        title: '行情交易',
        desc: 'With the help of materials including templates, graphics, videos and visualization charts and technologies including intelligent color scheme recommendations, data entry and tag retrieval, shorts creators can visualize complex content with improved efficiency',
        icon: require('@/assets/images/securitiessolutions/securitiesSolutions-maketTrading.png'),
        activeIcon: require('@/assets/images/securitiessolutions/securitiesSolutions-maketTrading-active.png'),
        index: 2
      }, {
        title: '投顾展业',
        desc: 'With our NLP, multimodal image matching and other algorithms, we introduce the one-click text-to-video function, which allows quick shorts generation by merely uploading word text or inputting news links',
        icon: require('@/assets/images/securitiessolutions/securitiesSolutions-advisor.png'),
        activeIcon: require('@/assets/images/securitiessolutions/securitiesSolutions-advisor-active.png'),
        index: 3
      }, {
        title: '投资研究',
        desc: 'Thanks to our AI technologies such as 3D models, PTA, speech-driven facial animation, lip sync and body movement matching, AI virtual anchor in animal, cartoon and human styles with exclusive voices can be customized to adapt to various scenarios',
        icon: require('@/assets/images/securitiessolutions/securitiesSolutions-research.png'),
        activeIcon: require('@/assets/images/securitiessolutions/securitiesSolutions-research-active.png'),
        index: 4
      }, {
        title: '投资者教育',
        desc: 'Template shorts can be posted on major platforms such as RoyalFlush and TikTok in user-defined forms at a pre-set time to maximize content exposure',
        icon: require('@/assets/images/securitiessolutions/securitiesSolutions-edu.png'),
        activeIcon: require('@/assets/images/securitiessolutions/securitiesSolutions-edu-active.png'),
        index: 5
      }, {
        title: '新闻资讯',
        desc: 'News: News websites, government agencies, local portals, listed companies, local websites, stock post bars, forums, we-media, etc.Financial data: Stocks (domestic and foreign markets), funds, bonds, treasury management, etc. Macro EDB: Covering 23 industries and 100+ countries and including 2mn+ macro and industry economic indicators',
        icon: require('@/assets/images/securitiessolutions/securitiesSolutions-news.png'),
        activeIcon: require('@/assets/images/securitiessolutions/securitiesSolutions-news-active.png'),
        index: 6
      }],
      activeIndex: 1,
      contentList: [{
        title: '网上开户',
        bg: require('@/assets/images/securitiessolutions/securitiesSolutions-onlineaccoutopenning-bg.png'),
        desc: '提供一站式线上投资理财服务，提升券商获客效率及服务体验，摆脱对实体网点的依赖。',
        index: 1
      }, {
        title: '行情交易',
        desc: '提供股票、债券、基金、期货、指数、外汇等品种行情报价及普通交易、智能交易服务。',
        bg: require('@/assets/images/securitiessolutions/securitiesSolutions-maketTrading-bg.png'),
        index: 2
      }, {
        title: '投顾展业',
        desc: '提供交易策略、基金组合、视频直播、图文观点、问股诊股、AI投资助手等一篮子工具，提升投顾服务水平',
        bg: require('@/assets/images/securitiessolutions/securitiesSolutions-advisor-bg.png'),
        index: 3
      }, {
        title: '投资研究',
        desc: '提供海量结构化、非结构化数据及投研工具，全方位辅助机构投资者投研决策。',
        bg: require('@/assets/images/securitiessolutions/securitiesSolutions-research-bg.png'),
        index: 4
      }, {
        title: '投资者教育',
        desc: '通过丰富的图文、视频、直播及模拟炒股等产品，提供多维网络投教服务。',
        bg: require('@/assets/images/securitiessolutions/securitiesSolutions-edu-bg.png'),
        index: 5
      }, {
        title: '新闻资讯',
        desc: '提供包括资讯版权、资讯内容、数据、咨询服务、算法推荐等资讯服务。',
        bg: require('@/assets/images/securitiessolutions/securitiesSolutions-news-bg.png'),
        index: 6
      }]
    };
  }
};